import { useSearchParams } from 'next/navigation';
import { useAPI } from '@/services';

interface IUseRegStateOptions {
  enabled?: boolean;
  retry?: boolean;
}

export const useRegState = ({
  enabled = true,
  retry = true,
}: IUseRegStateOptions = {}) => {
  const searchParams = useSearchParams();
  const returnUrl = searchParams?.get('returnUrl');
  const childNationalId = searchParams?.get('childNationalId');
  const regStateInput = {
    ...(returnUrl ? { returnUrl } : {}),
    ...(childNationalId ? { childNationalId } : {}),
  };

  const { isLoading, data, ...rest } = useAPI(['user', 'getCustomerRegState'], {
    input: regStateInput,
    reactQueryOptions: {
      enabled: enabled,
      retry,
      /// Force refetch of getCustomerRegState API on mount to ensure the data reflects the latest state.
      refetchOnMount: 'always',
    },
  });

  const regStateReturnUrl = data?.returnUrl;
  const isRegisterCompleted = data?.completedRegister;
  const registerMessage = data?.message;
  const backButtonText = ['متوجه شدم، بازگشت به', data?.applicationName].join(
    ' '
  );
  // To determine when backend doesn't know from where user has completed their registration
  const isRegisterCompleteSourceUnknown =
    !data?.applicationName || !data?.returnUrl;

  return {
    isLoading,
    data,
    regStateReturnUrl,
    isRegisterCompleted,
    registerMessage,
    backButtonText,
    isRegisterCompleteSourceUnknown,
    ...rest,
  };
};
